import { Routes } from '@angular/router';

import {HeroRedirectGuard} from "lib-hero";
import {BooxNoSessionGuard, BooxSessionGuard} from "lib-boox";

import {EmptyComponent} from "./component/empty/empty.component";

import {PublicLayoutComponent} from "./layout/public-layout/public-layout.component";
import {RestrictedLayoutComponent} from "./layout/restricted-layout/restricted-layout.component";

import {SignInViewComponent} from "./view/sign-in-view/sign-in-view.component";
import {ForgotPasswordViewComponent} from "./view/forgot-password-view/forgot-password-view.component";
import {ResetPasswordViewComponent} from "./view/reset-password-view/reset-password-view.component";

import {ApplicationViewComponent} from "./view/application-view/application-view.component";
import {ProfileViewComponent} from "./view/profile-view/profile-view.component";
import {SettingViewComponent} from "./view/setting-view/setting-view.component";

import {NotFoundViewComponent} from "./view/not-found-view/not-found-view.component";

export const routes: Routes = [
  {
    path : '',
    pathMatch: 'full',
    component: EmptyComponent,
    canActivate: [HeroRedirectGuard],
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'sign-in',
        component: SignInViewComponent,
        canActivate: [BooxNoSessionGuard],
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordViewComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordViewComponent,
      },
      {
        path: '404',
        component: NotFoundViewComponent,
      }
    ]
  },
  {
    path: '',
    component: RestrictedLayoutComponent,
    canActivateChild: [BooxSessionGuard],
    children: [
      {
        path: 'profile',
        component: ProfileViewComponent,
      },
      {
        path: 'settings',
        component: SettingViewComponent,
      },
      {
        path: 'app',
        children: [
          {
            path: '',
            component: EmptyComponent
          },
          {
            path: ':application',
            children: [{
              path: '**',
              component: ApplicationViewComponent,
            }]
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];
